import logger from '@/lib/logger.js'
import MonthIterator from '@/lib/MonthIterator.js'
import { Forecast } from '@/lib/Forecast.js'

const MONTH_LABELS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
]

let COLOR_TABLE = [
    '#00CA58', 
    '#2300CA',
    '#E7007D',
    '#FFF720',
    '#22F9FF',
    '#FF2F2F',
    '#960047',
    '#6370FF',
    '#005F2E',
    '#7C3B00',
    '#FF8394',
    '#C0B5FF',
    '#BAFFD0',
    '#FFDCB8'
]


function getRandomColor() {
    return '#000000'    // todo
}

function getColor(index) {
    let color = COLOR_TABLE[index]
    if (color === undefined) {
        color = getRandomColor()
        COLOR_TABLE[index] = color
    }    
    return color
}

let ChartDataBuilder = {
    build(reportData, varGroup, numMonths) {        
        logger.log('ChartDataBuilder::build()', { reportData: reportData, varGroup: varGroup })

        if (numMonths === undefined || numMonths <= 0)
            numMonths = reportData.numMonths

        if (reportData == null || varGroup == null || reportData.data.length == 0) {
            logger.log('reportData or varGroup is null or no datasets found')
            return
        }

        var forecast = new Forecast(reportData.forecast)
        var monthIterator = new MonthIterator(forecast.forecastID.getFirstForecastDate())

        var labels = []
        for(let i=0; i < numMonths; i++) {
            labels.push(MONTH_LABELS[monthIterator.month-1])
            monthIterator.nextMonth()
        }
               
        let chartData = {
            labels: labels,
            pageTitle: 'Report for Forecast: ' + forecast.forecastID.toString(),
            forecastChart: {
                title: '',
                units: '',
                series: []
            },
            historicalChart: {
                title: '',
                units: '',
                series: []
            }
        }        

        let buildSeries = (point, sourceData, resultData, index, titlePrefix) => {
            if (sourceData == null)
                return
            
            if (resultData.title == '') {
                let title = sourceData.name
                if (sourceData.units != '') 
                    title = title + ' (' + sourceData.units + ')'
                if (titlePrefix !== undefined)
                    title = titlePrefix + ' ' + title
                resultData.title = title
                resultData.units = sourceData.units
            }

            let series = {
                name: point.name,
                values: sourceData.values,
                color: getColor(index)
            }

            resultData.series.push(series)
        }

        reportData.data.forEach((dataset, index) => {
            let forecastItem = dataset.forecastData.find((item) => item.varGroup == varGroup)
            let historicalItem = dataset.historicalData.find((item) => item.varGroup == varGroup)

            buildSeries(dataset.point, forecastItem, chartData.forecastChart, index)
            buildSeries(dataset.point, historicalItem, chartData.historicalChart, index, 'Historical')
        })

        return chartData
    }
}

export default ChartDataBuilder